import { visitsDomain, partnersDomain } from '../../Common/constants';

export const rejectedUrl = `${visitsDomain}/visit-rejected/`;

export const partnersUrl = `${partnersDomain}/partner/`;

export const agenciesUrl = `${partnersDomain}/agency/`;
